<template>
  <div class="nav-footer">
    <div class="footerpc">
      <el-row class="choise">
        <el-col :span="4">
          <div class="logos">
            <a href="/" target="_blank">
              <img
                class="logo"
                src="../../assets/images/Group 11880.png"
                alt=""
              />
            </a>
          </div>
        </el-col>
        <el-col :span="10">
          <div class="grid soya-grid">
            <el-col :span="$t('lang') == 'en' ? 6 : 4"
              ><p @click="goToWeb('#/legalNotice')">
                {{ $t("legal_notice") }}
              </p>
            </el-col>

            <el-col :span="$t('lang') == 'en' ? 6 : 8">
              <p @click="goToWeb('#/privacyPolicy')">
                {{ $t("privacy_policy") }}
              </p></el-col
            >
            <el-col :span="6"
              ><p @click="goToWeb('#/cookieSetting')">
                {{ $t("cookie_policy") }}
              </p></el-col
            >
            <el-col :span="6"
              ><p @click="goToWeb('#/contactUs')">
                {{ $t("contact") }}
              </p></el-col
            >
          </div>
        </el-col>
        <el-col :span="10">
          <div class="grid-content">
            <img
              class="twitter"
              src="@/assets/images/Facebook.png"
              @click="
                goToWeb(
                  'https://www.facebook.com/gwmoraeurope'
                )
              "
            />
            <img
              class="twitter"
              src="@/assets/images/Twitter.png"
              @click="goToWeb('https://twitter.com/gwm_ora_europe')"
            />
            <img
              class="twitter"
              src="@/assets/images/Instagram.png"
              @click="
                goToWeb('https://www.instagram.com/gwm_ora_europe/')
              "
            />
            <!-- <span class="linshi"></span> -->
            <img
              class="twitter"
              src="@/assets/images/Pinterest.png"
              @click="
                goToWeb(
                  'https://www.pinterest.de/gwm_ora_europe'
                )
              "
            />
            <img class="dao" src="@/assets/images/footerDao.png" />
            <div class="hp">
              <p class="hp1">{{ $t("mobile-download1") }}</p>
              <p class="hp2">{{ $t("mobile-download2") }}</p>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- <el-row class="text">
        <el-col :span="22">
          <div class="">
            GWM ORA IS A REGISTERED TRADEMARK OF GREAT WALL. ALL RIGHTS RESERVED
            © 2021 GREAT WALL
          </div>
        </el-col>
      </el-row> -->
    </div>
    <div class="footermoblie">
      <el-row class="choise">
        <el-col :span="9">
          <div class="logos">
            <!-- <router-link to="/home">
              <img
                class="logo"
                src="../../assets/images/Group 11880.png"
                alt=""
              />
            </router-link> -->
          </div>
        </el-col>
        <el-col :span="24">
          <div class="grid">
            <el-col :xs="12" class="lineheight"
              ><p @click="goToWeb('#/legalNotice')">
                {{ $t("legal_notice") }}
              </p></el-col
            >
            <el-col :xs="12" class="lineheight"
              ><p @click="goToWeb('#/contactUs')">
                {{ $t("contact") }}
              </p></el-col
            >
            <el-col :xs="12" class="lineheight"
              ><p @click="goToWeb('#/cookieSetting')">
                {{ $t("cookie_policy") }}
              </p></el-col
            >

            <el-col
              :xs="12"
              class="lineheight"
              :class="{ isDE: $t('lang') == 'de' }"
              ><p @click="goToWeb('#/privacyPolicy')">
                {{ $t("privacy_policy") }}
              </p></el-col
            >
          </div>
        </el-col>
        <el-col :span="24">
          <div class="grid-content">
            <img
              class="xslogo"
              style="margin: 0 9px"
              src="@/assets/images/Facebook.png"
              @click="
                goToWeb(
                  'https://www.facebook.com/gwmoraeurope'
                )
              "
            />
            <img
              class="xslogo"
              style="margin: 0 9px"
              src="@/assets/images/Twitter.png"
              @click="goToWeb('https://twitter.com/gwm_ora_europe')"
            />
            <img
              class="xslogo"
              style="margin: 0 9px"
              src="@/assets/images/Instagram.png"
              @click="
                goToWeb('https://www.instagram.com/gwm_ora_europe/')
              "
            />
            <img
              class="xslogo"
              style="margin: 0 9px"
              src="@/assets/images/Pinterest.png"
              @click="
                goToWeb(
                  'https://www.pinterest.de/gwm_ora_europe'
                )
              "
            />
          </div>
        </el-col>
        <el-col :span="24">
          <div class="intro">
            <div class="intrologo" @click="handleDownload" target="_blank">
              <img src="@/assets/images/mobile-download.png" alt="" />
              <!-- <img class="logo" src="../../assets/images/Group 11880.png" />
              <div class="picture">
                <img
                  class="gwm"
                  src="../../assets/images/Layer 1 1.png"
                  alt=""
                />
                <img class="ora" src="../../assets/images/logo.png" alt="" />
              </div> -->
            </div>
            <div class="hp">
              <p class="hp1">{{ $t("mobile-download1") }}</p>
              <p class="hp2">{{ $t("mobile-download2") }}</p>
              <p class="hp-download" :class="{en: $t('lang') == 'en'}" @click="handleDownload">
                {{ $t("downloadBtn") }}
              </p>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- <el-row class="textm">
        <el-col :span="19">
          <p class="wall">
            GWM ORA IS A REGISTERED TRADEMARK OF GREAT WALL. ALL RIGHTS
            RESERVED © 2021 GREAT WALL
          </p>
        </el-col>
      </el-row> -->
    </div>
  </div>
</template>
<script>
// import { isIos } from "@/utils/index.js";
export default {
  methods: {
    goToWeb(url) {
      window.open(url);
    },
    handleDownload() {
      window.location.href =
        "https://eu-cdn-h5-html.gwmcloud.com/h5/html/oraShare.html";
    },
  },
};
</script>
<style lang="scss" scoped>
.isDE {
  margin-top: 10px;
  word-wrap: break-word;
  word-break: break-all;
  p {
    line-height: 20px;
  }
}
// 显示pc内容
@media screen and (min-width: 768px) {
  .footermoblie {
    display: none;
  }

  .footerpc {
    /* height: 240px; */
    display: block;
    border-top: 1px solid #333;
    border-bottom: 1px solid #333;
  }
  .choise {
    height: 141px;
    background: #eaeaea;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .logos .logo {
    // height: 40px;
    width: 95px;
  }
  .picture {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .logos .picture .gwm {
    width: 52px;
    height: 12px;
    margin-left: -1%;
  }
  .logos .picture .ora {
    width: 52px;
    height: 16px;
    margin-left: 2%;
  }
  .grid {
    font-size: 14px;
    cursor: pointer;
    text-align: left;
    padding-top: 14px;
    .el-col-24 {
      width: 20%;
    }
  }
  .grid-content {
    display: flex;
    align-items: center;
    img {
      cursor: pointer;
    }
  }
  .twitter {
    margin: 0 3%;
    margin-left: 20px;
  }
  .xslogo {
    margin-left: 10px;
  }
  .dao {
    width: 60px;
    height: 60px;
    cursor: default !important;
    /* margin-left: 20px !important; */
  }
  .text {
    margin: 3% 0;
  }
  .hp {
    width: 270px;
    height: 60px;
    text-align: left;
    margin-left: 12px;
    // padding-right: 5px;
    font-family: "NexaBold";
  }

  .hp1 {
    font-size: 14px;
    color: #000;
  }
  .hp2 {
    font-size: 12px;
    color: #989797;
    margin-top: 5px;
    line-height: 20px;
  }
}

@media screen and (max-width: 1390px) {
  .soya-grid {
    p {
      font-size: 12px;
    }
  }
  .hp1 {
    font-size: 13px;
  }
  .hp2 {
    font-size: 10px;
  }
}
// 移动
@media screen and (max-width: 767px) {
  .footerpc {
    display: none;
  }
  .footermoblie {
    height: 100%;
  }
  .choise {
    // height: 449px;
    background: #eaeaea;
    padding: 10px 0 30px 0;
  }
  .logos {
    padding: 0 0 !important;
    width: 155px;
  }
  .logo {
    // width: 16px;
    // height: 29px;
    width: 73px;
  }
  .gwm {
    width: 35px;
    height: 8px;
  }
  .ora {
    width: 35px;
    height: 8px;
    margin-left: 10px;
  }
  .grid {
    margin-top: 6%;
  }
  .lineheight {
    line-height: 40px;
    text-align: left;
    padding-left: 37px;
    font-size: 12px;
    color: #939597;
  }
  .grid-content {
    border-bottom: 1px solid #999;
    height: 70px;
    margin-top: 16px;
    display: flex;
    align-items: left;
    justify-content: space-evenly;
    // justify-content: flex-start;
    // margin-left: 10px;
    // padding-left: 28px;
  }
  .footermoblie .choise .intro {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 8px;
    margin-top: 6px;
    padding: 0 45px;
  }
  .intrologo {
    // margin-top: 10px;
    // border: #d1d1d1 2px solid;
    // border-radius: 20%;
    // background: #fff;
    height: 84px;
    width: 84px;
    justify-content: space-between;
    // padding: 5% 0 0 0;
    img {
      width: 100%;
    }
  }
  .intrologo div {
    display: flex;
    width: 60px;
    margin: 0% 10px;
    justify-content: space-between;
  }
  .intrologo div p {
    color: #000 !important;
    font-weight: bold !important;
    font-size: 8px;
  }
  .hp {
    height: 60px;
    text-align: left;
    width: 175px;
    height: 30px;
    margin-left: 20px;
    margin-top: -40px;
    font-family: "NexaBold";
    .hp1 {
      font-size: 14px;
      color: #000;
      margin: -5px 0 5px 0;
    }
    .hp2 {
      font-size: 11px;
      color: #989797;
    }
    .hp-download {
      &.en {
        margin-top: 5px;
      }
      display: inline-block;
      // width: 86px;
      margin-top: 2px;
      font-size: 12px;
      height: 22px;
      line-height: 22px;
      border: 1px solid #000;
      text-align: center;
      color: #000;
      font-weight: 700;
      font-family: NexaLight;
      padding: 0 8px;
      border-radius: 100px;
    }
  }
  .intro div p {
    color: #939597;
    font-size: 12px;
  }
  .intro div h5 {
    color: #333;
  }
  .footermoblie .textm {
    height: 97px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .wall {
    font-size: 12px;
    font-weight: 300;
    line-height: 15px;
    text-align: left;
    text-transform: uppercase;
  }
}
.linshi {
  width: 39px;
  height: 39px;
  margin: 0 4%;
}
.linshi_ins {
  // margin-right: 50px;
}
</style>